import { render, staticRenderFns } from "./CreateBranchOperatingZonesModal.vue?vue&type=template&id=1ff227fc&"
import script from "./CreateBranchOperatingZonesModal.vue?vue&type=script&lang=ts&"
export * from "./CreateBranchOperatingZonesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports